import React from "react";
import { nextId } from "./idGenerator";

export interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> {
  label?: React.ReactNode;
  className?: string;
  inputClassName?: string;
  labelClassName?: string;
}

function Checkbox({
  label,
  className,
  inputClassName,
  labelClassName,
  id,
  ...rest
}: CheckboxProps) {
  const [generatedId] = React.useState(() => nextId("ui-checkbox"));
  const fieldId = id || generatedId;

  const wrapperClasses = ["ui-checkbox", className].filter(Boolean).join(" ");
  const inputClasses = ["ui-checkbox__input", inputClassName].filter(Boolean).join(" ");
  const labelClasses = ["ui-checkbox__label", labelClassName].filter(Boolean).join(" ");

  return (
    <span className={wrapperClasses}>
      <input {...rest} type="checkbox" id={fieldId} className={inputClasses} />
      {label ? (
        <label className={labelClasses} htmlFor={fieldId}>
          {label}
        </label>
      ) : null}
    </span>
  );
}

export default Checkbox;
